export const toHome = "/home";
export const toVideos = "/videos";
export const toStoryIntro = "/story";
export const toStory = (storyId) => "/story/" + storyId;
export const toQuizOverview = "/learning";
export const toSubtopicView = (quizpartId) =>  "/learning/" + quizpartId;
export const toQuestionsView = (quizpartId, subtopicId, activeQuestion=0) =>  "/learning/" + quizpartId + "/" + subtopicId + "/" + activeQuestion;
export const toProgress = "/progress";
export const toMaterials = "/materials";

export const toPublications = "/publications";

export const toSurveyStart = "/umfrage/start";
export const toSurveyMain = "/umfrage/standard";
export const toSurveyFinish = "/umfrage/ende";